// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"237ee0bfb41b03686c4c","655":"dc94e74e54bfdbb02496"}[chunkId] + ".js";
};